module.exports = __webpack_public_path__ + "img/12_5.5d1f99f5.png";